"use client";
import { Link } from "@/i18n/routing";
import { useEffect, useState } from "react";
function isWebView() {
    const userAgent = window.navigator && navigator.userAgent;

    return /WebView|iPhone|iPod|Android/.test(userAgent);
}
const DownloadSection = () => {
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
        const isCloseDownload = sessionStorage.getItem("isCloseDownload");
        if (isWebView() || isCloseDownload) {
            setVisible(false);
        }
    }, []);

    const closeDownloadSection = () => {
        sessionStorage.setItem("isCloseDownload", "true");
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div
            className={"relative flex items-center px-[0.1389rem] py-[0.0694rem]"}
            style={{
                background: "linear-gradient(169deg,#4d820b,rgba(0,75,61))",
            }}
        >
            <div
                className={
                    "absolute -left-[0px] -top-[0px] h-[0.22rem] w-[0.24rem] text-[0.1rem]" +
                    " rounded-br-[0.3472rem] indent-[0.05rem] leading-[0.17rem]" +
                    " bg-[#d8d8d8] text-[#000]"
                }
                onClick={closeDownloadSection}
            >
                <i className={"iconfont icon-guanbi text-[0.1rem]"}></i>
            </div>
            <div className={"ml-[0.1389rem] flex-1"}>
                <p className={"font-bold text-[#b6ff00]"}>BCWIN777</p>
                <p className={"text-[0.1rem] font-bold"}>
                    Baixe o APP e ganhe um pontos grátis de 10 pontos
                </p>
            </div>
            <Link
                href={"/download"}
                className={
                    "flex h-[0.33rem] rounded-[0.04rem] bg-[#a0f10d] p-[0.12rem] " +
                    " items-center justify-center text-[0.12rem] text-[#000]"
                }
            >
                <i className={"iconfont icon-android text-[0.25rem]"}></i>
                <p className={"font-bold"}>BAIXE</p>
            </Link>
        </div>
    );
};

export default DownloadSection;
